export const DOC_UPLOAD_STATUS_NONE = 'none'
export const DOC_UPLOAD_STATUS_ACCEPTED = 'accepted'
export const DOC_UPLOAD_STATUS_UPLOADING = 'uploading'
export const DOC_UPLOAD_STATUS_SUCCESS = 'success'
export const DOC_UPLOAD_STATUS_ERROR = 'error'
export const DOC_UPLOAD_STATUS_DUPLICATE = 'duplicate'

export const documentUploadStatuses = Object.freeze({
    none: {
        key: DOC_UPLOAD_STATUS_NONE,
        text: 'Unknown',
        class: 'text-info',
        bgClass: 'bg-info',
        icon: 'fal fa-info-circle'
    },
    accepted: {
        key: DOC_UPLOAD_STATUS_ACCEPTED,
        text: 'Accepted',
        class: 'text-info',
        bgClass: 'bg-info',
        icon: 'fal fa-vote-yea'
    },
    uploading: {
        key: DOC_UPLOAD_STATUS_UPLOADING,
        text: 'Uploading',
        class: 'text-primary-light',
        bgClass: 'bg-primary-light',
        icon: 'fal fa-spinner fa-pulse'
    },
    success: {
        key: DOC_UPLOAD_STATUS_SUCCESS,
        text: 'Successfully uploaded',
        class: 'text-success',
        bgClass: 'bg-success',
        icon: 'fal fa-check-double'
    },
    error: {
        key: DOC_UPLOAD_STATUS_ERROR,
        text: 'Something went wrong',
        class: 'text-danger',
        bgClass: 'bg-danger',
        icon: 'fal fa-exclamation-circle'
    },
    duplicate: {
        key: DOC_UPLOAD_STATUS_DUPLICATE,
        text: 'This document matches one previously added. To prevent duplicates we’ve skipped this one.',
        class: 'text-warning',
        bgClass: 'bg-warning',
        icon: 'fal fa-exclamation-triangle'
    }
})

export const documentUploadStatusesList = Object.freeze(Object.values(documentUploadStatuses))

export const getDocUploadStatusModelByKey = key => {
    return documentUploadStatusesList.find(m => m.key === key) || documentUploadStatuses.none
}

// None = "",
// Added = "added",
// Queued = "queued",
// Accepted = "queued",
// Uploading = "uploading",
// Canceled = "canceled", TODO
// Error = "error",
// Timeout = "timeout", TODO
// Success = "success",
